import React, { useEffect, useRef } from 'react';

export const useClickOutside = (handler: () => void) => {
  const domNode: React.RefObject<HTMLDivElement> = useRef(null);

  useEffect(() => {
    const maybeHandler = (event: MouseEvent) => {
      if (!domNode.current?.contains(event.target as Node)) {
        if (handler) {
          handler();
        }
      }
    };

    document.addEventListener('mousedown', maybeHandler);

    return () => {
      document.removeEventListener('mousedown', maybeHandler);
    };
  });

  return domNode;
};
